import React from 'react'
import { cardStyle, white, textPrimary, borderDefault } from './styles'

function CurrentCard({ event, isLoading }) {

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: white,
        borderTop: `2px solid ${borderDefault}`,
        padding: '12px 16px',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        zIndex: 100,
      }}
    >
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div style={{ marginBottom: '12px' }}>
          <div style={{ fontSize: '0.7rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#aaa', marginBottom: '4px' }}>Current Event</div>
          <div style={{ fontSize: '1.1rem', fontWeight: '600', color: textPrimary, marginBottom: '4px' }}>{event.title}</div>
          <div style={{ fontSize: '0.9rem', color: '#666', fontWeight: '600' }}>Year: ???</div>
        </div>

        <p role="status" style={{ margin: 0, fontSize: '.9rem', color: '#666' }}>
          {isLoading ? 'Placing…' : 'Tap a position on the timeline to place this event immediately.'}
        </p>
      </div>
    </div>
  )
}

export default CurrentCard
